import { Flex, Typography } from "antd";
import emptyStateClient from "../../assets/bg/no_client.svg";
import useSpecialityReference from "../../hooks/useSpecialityReference";

interface EmptyStateClientProps {
  segment?: string;
}

const EmptyStateClient = ({ segment = "my" }: EmptyStateClientProps) => {
  const { referIndividualBy } = useSpecialityReference();

  const getEmptyMessage = () => {
    if (segment === "shared") {
      return `No ${referIndividualBy.toLowerCase()}s have been shared.`;
    }
    return `Add ${referIndividualBy}s here.`;
  };

  const getSubMessage = () => {
    if (segment === "shared") {
      return `${referIndividualBy}s shared by colleagues will appear here.`;
    }
    return "Secure & HIPAA-Compliant.";
  };

  return (
    <Flex vertical align="center" justify="center">
      <img src={emptyStateClient} width={"50px"} alt="Empty State Client" />
      <Typography
        style={{
          color: "var(--secondary-text)",
          fontSize: "20px",
          marginTop: "10px",
        }}
      >
        {getEmptyMessage()}
      </Typography>
      <Typography
        style={{
          color: "var(--grey-text)",
        }}
      >
        {getSubMessage()}
      </Typography>
    </Flex>
  );
};

export default EmptyStateClient;
